var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isInvoicingEnabled)?_c('PaidFeatureNotEnabled',{attrs:{"header":_vm.config.header,"feature":"Invoicing"}}):_c('EntitiesTable',{attrs:{"config":_vm.config,"showDownloadCsvButton":false,"showAddButton":"","showEditButton":"","showDeleteButton":"","showSearch":"","showActions":""},scopedSlots:_vm._u([{key:"item.id",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("uuidLast6")(item.id))+" ")]}},{key:"item.cost",fn:function(ref){
var item = ref.item;
return [_vm._v(" $"+_vm._s(_vm.getCost(item))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }